// Translations
import modelTransaction from '../components/model-transaction/translations/tr'

// Translation: Account > Billing > Recurring transactions (Turkish)
export default Object.freeze({
	components: { modelTransaction },
	fallback: {
		empty: 'İşlem bulunamadı.',
		unavailable: 'Bilgi mevcut değil.'
	},
	title: 'Yinelenen işlem geçmişi',
	transactionTypeItems: {
		ASSET_HOSTING: 'Nesne barındırma',
		ASSET_REFUND: 'Nesne iadesi',
		ASSET_USAGE: 'Nesne kullanımı',
		AUTO_TOP_UP: 'Otomatik kredi doldurma',
		EXPIRABLE_CREDIT: 'Süresi dolabilen kredi',
		PAY_OUT: 'Giden ödeme',
		RESERVE_ASSET_USAGE: 'Rezerve nesne kullanımı',
		SERVICE_ASSET_USAGE: 'Servis nesne kullanımı',
		SUBSCRIPTION: 'Abonelik',
		TOP_UP: 'Kredi doldurma',
		TRANSFER: 'Transfer',
		TRIAL_TOP_UP: 'Deneme kredisi doldurma',
		UNSUBSCRIBE: 'Abonelikten çıkma'
	}
})
